import {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {getHomeData} from '../../redux/actions/dataActions'
import CustomerDocs from './customerDocs/CustomerDocs'
import './Documents.css'
import TruckDocs from './truckDocs/TruckDocs'
import UtiRequests from './utiRequests/UtiRequests'

function Documents(props) {
  

  
    return (
      <div className="width-100">
        <h5 className='title-docs'>מסמכים</h5>
        <div className='row-docs'>
          <TruckDocs />
          <CustomerDocs />
          <UtiRequests />
        </div>
      </div> 
    )
  
}

export default Documents
